import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import GestaoAssinantesPage from "./GestaoAssinantesPage";
import GestaoCotacaoAssinantesPage from "./GestaoCotacaoAssinantesPage";
import GestaoVaiPedeAssinantesPage from "./GestaoVaiPedeAssinantesPage";
import { Crown, FileSpreadsheet, Utensils } from "lucide-react";

export default function GestaoAssinantesUnificadaPage() {
  const [tab, setTab] = useState("compromisso");

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6" data-testid="gestao-unificada">
      <div className="mb-4">
        <h1 className="text-2xl font-bold flex items-center gap-2">
          <Crown className="w-6 h-6 text-amber-600" /> Gestão de Assinantes
        </h1>
        <p className="text-sm text-slate-500 mt-1">Gerencie os assinantes dos 3 produtos SaaS separadamente.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="mb-4">
          <TabsTrigger value="compromisso" data-testid="tab-compromisso">
            <Crown className="w-4 h-4 mr-1.5" /> Compromisso Digital
          </TabsTrigger>
          <TabsTrigger value="cotacao" data-testid="tab-cotacao">
            <FileSpreadsheet className="w-4 h-4 mr-1.5" /> Sistema de Cotações
          </TabsTrigger>
          <TabsTrigger value="vaipede" data-testid="tab-vaipede">
            <Utensils className="w-4 h-4 mr-1.5 text-[#EA1D2C]" /> VAI PEDE
          </TabsTrigger>
        </TabsList>

        <TabsContent value="compromisso" className="mt-0">
          <GestaoAssinantesPage />
        </TabsContent>
        <TabsContent value="cotacao" className="mt-0">
          <GestaoCotacaoAssinantesPage />
        </TabsContent>
        <TabsContent value="vaipede" className="mt-0">
          <GestaoVaiPedeAssinantesPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
